import React from 'react';
import { TreePine, Car, Trash2, Globe } from 'lucide-react';
import { SustainabilityOutputs as SustainabilityData } from '../../types/calculator';
import { MetricCard } from '../ui/MetricCard';
import { Card } from '../ui/Card';
import { formatWeight, formatNumber } from '../../utils/formatters';

interface RealWorldImpactOutputsProps {
  data: SustainabilityData;
}

export const RealWorldImpactOutputs: React.FC<RealWorldImpactOutputsProps> = ({ data }) => {
  return (
    <Card gradient>
      <h3 className="text-lg font-serif font-semibold text-offblack mb-4 flex items-center gap-2">
        <Globe className="w-5 h-5 text-[#C35E38]" />
        Real World Impact
      </h3>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <MetricCard
          icon={TreePine}
          label="Trees Planted"
          value={data.treesEquivalent}
          formatter={(v) => formatNumber(v, 1)}
          color="emerald"
        />

        <MetricCard
          icon={Car}
          label="CO₂ Offset"
          value={data.carKmOffset}
          formatter={(v) => `${formatNumber(Math.round(v), 0)} kms driven`}
          color="maroon"
        />

        <MetricCard
          icon={Trash2}
          label="Waste Avoided"
          value={data.wasteAvoided}
          formatter={formatWeight}
          color="maroon"
        />
      </div>
    </Card>
  );
};
